import {FactionsHash, FeudParticipantsHash, Feuds, Rosters, Superstars} from "./models.js";

function Faction() {

    // Strings
    const name = null;
    const objectName = 'faction';

    // Integer
    const reputation = null;
    const xp = 0;
    const xpGainedThisYear = 0;

    // Boolean
    const disbanded = false;

    // Arrays
    const formerMembers = [];

    // Foreign keys
    const rosterId = null;
    const leaderSuperstarId = null;

    return {
        name,
        reputation,
        xp,
        xpGainedThisYear,
        disbanded,
        formerMembers,
        rosterId,
        leaderSuperstarId,
        objectName,
    };
}

function getFactionRoster(faction) {
    return Rosters.find({'$loki': faction.rosterId})[0];
}

function addFactionSuperstars(faction, superstars) {
    let factionHashes = superstars.map(x => {
        return {factionId: faction.$loki, superstarId: x.$loki}
    });
    return FactionsHash.insert(factionHashes);
}

async function removeFactionSuperstars(faction, superstars) {
    const superstarIds = superstars.map(x => {
        return x.$loki
    });
    const factionHashesToRemove = await FactionsHash.where(
        x => x.factionId === faction.$loki && superstarIds.includes(x.superstarId));
    for (const x of factionHashesToRemove) {
        FactionsHash.remove(x);
    }
}

async function getFactionSuperstars(faction) {
    const factionHashes = await FactionsHash.find({'factionId': faction.$loki});
    const superstarIds = factionHashes.map(x => {
        return x.superstarId
    });
    return Superstars.find({'$loki': {'$in': superstarIds}})
}

function getFactionLeaderSuperstar(faction) {
    if (faction.leaderSuperstarId) {
        return Superstars.find({'$loki': faction.leaderSuperstarId})[0];
    }
    else {
        return null;
    }
}

function setFactionLeaderSuperstar(faction, superstar) {  // set_faction_leader
    faction.leaderSuperstarId = superstar.$loki;
}

function removeFactionLeaderSuperstar(faction) {
    faction.leaderSuperstarId = null;
}

async function getFactionFeuds(faction) {
    const feudHashes = await FeudParticipantsHash.find({'factionId': faction.$loki});
    const feudIds = feudHashes.map(x => {
        return x.feudId
    });
    return Feuds.find({'$loki': {'$in': feudIds}});
}

export {Faction, getFactionRoster, addFactionSuperstars, removeFactionSuperstars, getFactionSuperstars,
    getFactionLeaderSuperstar, removeFactionLeaderSuperstar, setFactionLeaderSuperstar, getFactionFeuds };